export default [
  {
    path: '/opinion',
    name: 'opinion',
    component: () => import('@/views/menu/public/opinion.vue'),
    meta: {
      pageTitle: 'مدیریت نظرهای مشتریان',
      action: 'show',
      resource: 'OpinionManager',
    },
  },
  {
    path: '/opinion/details',
    name: 'addopinion',
    component: () => import('@/views/menu/public/opiniondetails.vue'),
    meta: {
      pageTitle: 'ایجاد نظر',
      action: 'show',
      resource: 'OpinionManager',
    },
  },
  {
    path: '/opinion/details/:id',
    name: 'updateopinion',
    component: () => import('@/views/menu/public/opiniondetails.vue'),
    meta: {
      pageTitle: 'ویرایش نظر',
      action: 'show',
      resource: 'OpinionManager',
    },
  },
  {
    path: '/sitesetting',
    name: 'sitesetting',
    component: () => import('@/views/menu/public/sitesetting.vue'),
    meta: {
      pageTitle: 'مدیریت تنظیمات سایت',
      action: 'show',
      resource: 'SiteSettingManager',
    },
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/views/menu/public/faq.vue'),
    meta: {
      pageTitle: 'مدیریت سوالات متداول',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faq/details',
    name: 'addfaq',
    component: () => import('@/views/menu/public/faqdetails.vue'),
    meta: {
      pageTitle: 'ایجاد سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faq/details/:id',
    name: 'updatefaq',
    component: () => import('@/views/menu/public/faqdetails.vue'),
    meta: {
      pageTitle: 'ویرایش سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faqcategory',
    name: 'faqcategory',
    component: () => import('@/views/menu/public/faqcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی های سوالات متداول',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faq/details',
    name: 'addfaqcategory',
    component: () => import('@/views/menu/public/faqcategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد دسته بندی سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/faqcategory/details/:id',
    name: 'updatefaqcategory',
    component: () => import('@/views/menu/public/faqcategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش دسته بندی سوال',
      action: 'show',
      resource: 'FaqManager',
    },
  },
  {
    path: '/sickness',
    name: 'sickness',
    component: () => import('@/views/menu/public/sickness.vue'),
    meta: {
      pageTitle: 'مدیریت بیماری ها',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sickness/details',
    name: 'addsickness',
    component: () => import('@/views/menu/public/sicknessdetails.vue'),
    meta: {
      pageTitle: 'ایجاد بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sickness/details/:id',
    name: 'updatesickness',
    component: () => import('@/views/menu/public/sicknessdetails.vue'),
    meta: {
      pageTitle: 'ویرایش بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },

  {
    path: '/sicknesscategory',
    name: 'sicknesscategory',
    component: () => import('@/views/menu/public/sicknesscategory.vue'),
    meta: {
      pageTitle: 'مدیریت بیماری ها',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sicknesscategory/details',
    name: 'addsicknesscategory',
    component: () => import('@/views/menu/public/sicknesscategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/sicknesscategory/details/:id',
    name: 'updatesicknesscategory',
    component: () => import('@/views/menu/public/sicknesscategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش بیماری',
      action: 'show',
      resource: 'SicknessManager',
    },
  },
  {
    path: '/productslider',
    name: 'productslider',
    component: () => import('@/views/menu/public/productslider.vue'),
    meta: {
      pageTitle: 'مدیریت اسلایدرهای محصول',
      action: 'show',
      resource: 'ProductSliderManager',
    },
  },
  {
    path: '/productslider/details',
    name: 'addproductslider',
    component: () => import('@/views/menu/public/productsliderdetails.vue'),
    meta: {
      pageTitle: 'ایجاد اسلایدر محصول',
      action: 'show',
      resource: 'ProductSliderManager',
    },
  },
  {
    path: '/productslider/details/:id',
    name: 'updateproductslider',
    component: () => import('@/views/menu/public/productsliderdetails.vue'),
    meta: {
      pageTitle: 'ویرایش اسلایدر محصول',
      action: 'show',
      resource: 'ProductSliderManager',
    },
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import('@/views/menu/public/menu.vue'),
    meta: {
      pageTitle: 'مدیریت منو',
      action: 'show',
      resource: 'MenuManager',
    },
  },
  {
    path: '/menu/details',
    name: 'addmenu',
    component: () => import('@/views/menu/public/menudetails.vue'),
    meta: {
      pageTitle: 'ایجاد منو',
      action: 'show',
      resource: 'MenuManager',
    },
  },
  {
    path: '/menu/details/:id',
    name: 'updatemenu',
    component: () => import('@/views/menu/public/menudetails.vue'),
    meta: {
      pageTitle: 'ویرایش منو',
      action: 'show',
      resource: 'MenuManager',
    },
  },
  {
    path: '/content',
    name: 'content',
    component: () => import('@/views/menu/public/content.vue'),
    meta: {
      pageTitle: 'مدیریت محتواها',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/content/details',
    name: 'addcontent',
    component: () => import('@/views/menu/public/contentdetails.vue'),
    meta: {
      pageTitle: 'ایجاد محتوا',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/content/details/:id',
    name: 'updatecontent',
    component: () => import('@/views/menu/public/contentdetails.vue'),
    meta: {
      pageTitle: 'ویرایش محتوا',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/version',
    name: 'version',
    component: () => import('@/views/menu/public/version.vue'),
    meta: {
      pageTitle: 'مدیریت ورژن ها',
      action: 'show',
      resource: 'VersionManager',
    },
  },
  {
    path: '/version/details',
    name: 'addversion',
    component: () => import('@/views/menu/public/versiondetails.vue'),
    meta: {
      pageTitle: 'ایجاد ورژن',
      action: 'show',
      resource: 'VersionManager',
    },
  },
  {
    path: '/version/details/:id',
    name: 'updateversion',
    component: () => import('@/views/menu/public/versiondetails.vue'),
    meta: {
      pageTitle: 'ویرایش ورژن',
      action: 'show',
      resource: 'VersionManager',
    },
  },
  {
    path: '/urlmap',
    name: 'urlmap',
    component: () => import('@/views/menu/public/urlmap.vue'),
    meta: {
      pageTitle: 'مدیریت لینک ها',
      action: 'show',
      resource: 'UrlMapManager',
    },
  },
  {
    path: '/duty',
    name: 'duty',
    component: () => import('@/views/menu/duty/duty.vue'),
    meta: {
      pageTitle: 'مدیریت خدمات',
      action: 'show',
      resource: 'DutyManager',
    },
  },
  {
    path: '/duty/details',
    name: 'addduty',
    component: () => import('@/views/menu/duty/dutydetails.vue'),
    meta: {
      pageTitle: 'ایجاد خدمت',
      action: 'show',
      resource: 'DutyManager',
    },
  },
  {
    path: '/duty/details/:id',
    name: 'updateduty',
    component: () => import('@/views/menu/duty/dutydetails.vue'),
    meta: {
      pageTitle: 'ویرایش خدمت',
      action: 'show',
      resource: 'DutyManager',
    },
  },
  {
    path: '/dutyquestion',
    name: 'dutyquestion',
    component: () => import('@/views/menu/duty/dutyquestion.vue'),
    meta: {
      pageTitle: 'مدیریت فیلدهای سفارش',
      action: 'show',
      resource: 'DutyManager',
    },
  },
  {
    path: '/dutyquestion/details',
    name: 'adddutyquestion',
    component: () => import('@/views/menu/duty/dutyquestiondetails.vue'),
    meta: {
      pageTitle: 'ایجاد فیلد سفارش',
      action: 'show',
      resource: 'DutyManager',
    },
  },
  {
    path: '/dutyquestion/details/:id',
    name: 'updatedutyquestion',
    component: () => import('@/views/menu/duty/dutyquestiondetails.vue'),
    meta: {
      pageTitle: 'ویرایش فیلد سفارش',
      action: 'show',
      resource: 'DutyManager',
    },
  },
  {
    path: '/exhibition',
    name: 'exhibition',
    component: () => import('@/views/menu/exhibition/exhibition.vue'),
    meta: {
      pageTitle: 'مدیریت نمایشگاه ها',
      action: 'show',
      resource: 'ExhibitionManager',
    },
  },
  {
    path: '/exhibition/details',
    name: 'addexhibition',
    component: () => import('@/views/menu/exhibition/exhibitiondetails.vue'),
    meta: {
      pageTitle: 'ایجاد نمایشگاه',
      action: 'show',
      resource: 'ExhibitionManager',
    },
  },
  {
    path: '/exhibition/details/:id',
    name: 'updateexhibition',
    component: () => import('@/views/menu/exhibition/exhibitiondetails.vue'),
    meta: {
      pageTitle: 'ویرایش نمایشگاه',
      action: 'show',
      resource: 'ExhibitionManager',
    },
  },
  {
    path: '/companyhistory',
    name: 'companyhistory',
    component: () => import('@/views/menu/public/companyhistory.vue'),
    meta: {
      pageTitle: 'مدیریت تاریخچه',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/companyhistory/details',
    name: 'addcompanyhistory',
    component: () => import('@/views/menu/public/companyhistorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد تاریخچه',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/companyhistory/details/:id',
    name: 'updatecompanyhistory',
    component: () => import('@/views/menu/public/companyhistorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش تاریخچه',
      action: 'show',
      resource: 'ContentManager',
    },
  },
  {
    path: '/state',
    name: 'state',
    component: () => import('@/views/menu/public/state.vue'),
    meta: {
      pageTitle: 'مدیریت استان ها',
      action: 'show',
      resource: 'StateManager',
    },
  },
  {
    path: '/city',
    name: 'city',
    component: () => import('@/views/menu/public/city.vue'),
    meta: {
      pageTitle: 'مدیریت شهرها',
      action: 'show',
      resource: 'CityManager',
    },
  },
  {
    path: '/newsletter',
    name: 'newsletter',
    component: () => import('@/views/menu/public/newsletter.vue'),
    meta: {
      pageTitle: 'مدیریت خبرنامه',
      action: 'show',
      resource: 'NewsletterManager',
    },
  },
  {
    path: '/brochure',
    name: 'brochure',
    component: () => import('@/views/menu/public/brochure.vue'),
    meta: {
      pageTitle: 'مدیریت بروشور',
      action: 'show',
      resource: 'BrochureManager',
    },
  },
  {
    path: '/brochure/details',
    name: 'addbrochure',
    component: () => import('@/views/menu/public/brochuredetails.vue'),
    meta: {
      pageTitle: 'ایجاد بروشور',
      action: 'show',
      resource: 'BrochureManager',
    },
  },
  {
    path: '/brochure/details/:id',
    name: 'updatebrochure',
    component: () => import('@/views/menu/public/brochuredetails.vue'),
    meta: {
      pageTitle: 'ویرایش بروشور',
      action: 'show',
      resource: 'BrochureManager',
    },
  },
  // {
  //   path: '/report',
  //   name: 'report',
  //   component: () => import('@/views/menu/public/report.vue'),
  //   meta: {
  //     pageTitle: 'مدیریت گزارش ها',
  //     action: 'show',
  //     resource: 'ReportManager',
  //   },
  // },
  // {
  //   path: '/report/details/:id',
  //   name: 'updatereport',
  //   component: () => import('@/views/menu/public/reportdetails.vue'),
  //   meta: {
  //     pageTitle: 'ویرایش گزارش',
  //     action: 'show',
  //     resource: 'VersionManager',
  //   },
  // },
]
